export class MoovConfigurationStatusDTO {
    public id!: number;
    public customerName!: string;
    public customerId!: number;
    public clientName!: string;
    public clientId!: number;
    public moovName!: string;
    public moovDefinitionId!: number;
    public status!: number; //0=Draft, 1=Testing, 2=Active, 3=Inactive
    public filenameStartsWith!: string;
    public filenameContains!: string;
    public added!: string;
    public edited!: string;
    public lastExecutedMoovInstanceId!: number;
    public lastExecutedStatus!: number;
    public lastAddedAt!: string;
    public lastExecutedOnOlderConfiguration!: boolean; //flag if configuration is outdated
}